var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42063 7.74999C4.10257 8.08328 3.57184 8.08328 3.25378 7.74999L0.237793 4.58961C-0.0792644 4.25737 -0.0792644 3.70451 0.237793 3.37227L0.891863 2.68689C1.20972 2.35381 1.72185 2.3536 2.03995 2.68626L3.84519 4.56119L7.95944 0.249967C8.27751 -0.0833222 8.79007 -0.0833222 9.10813 0.249967L9.7622 0.935351C10.0793 1.26759 10.0793 1.82045 9.7622 2.15269L4.42063 7.74999Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.1b408921af70b6dcaa716b74fd2e36de.svg";
export { ForwardRef as ReactComponent };